"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlCartesian2dPlotFactory = void 0;
const core_1 = require("@visualization-tools/core");
const cartesian2d_plot_ctor_arg_1 = require("./cartesian2d-plot-ctor-arg");
const gl_cartesian_2d_trace_binder_1 = require("../axis/traces/gl-cartesian-2d-trace-binder");
const cartesian_2d_trace_entity_connector_1 = require("../axis/cartesian-2d-trace-entity-connector");
const create_cartesian_plot_ctor_1 = require("./create-cartesian-plot-ctor");
const gl_cartesian2d_camera_binder_1 = require("../camera/gl-cartesian2d-camera-binder");
const gl_cartesian_2d_trace_graphics_component_1 = require("../axis/traces/gl-cartesian-2d-trace-graphics-component");
const populate_cartesian_2d_trace_bindings_1 = require("../axis/populate-cartesian-2d-trace-bindings");
const gl_cartesian_2d_axis_graphics_component_1 = require("../axis/labels/gl-cartesian-2d-axis-graphics-component");
const gl_cartesian_update_hooks_1 = require("../update/update-arg/gl-cartesian-update-hooks");
/**
 * @public
 * Creates a Cartesian 2d plot.
 */
class GlCartesian2dPlotFactory {
    static createOne(chart, options) {
        const plotArea = options.getPlotArea(chart.attachPoint);
        const arg = new cartesian2d_plot_ctor_arg_1.Cartesian2dPlotCtorArg(chart, options, plotArea);
        return new GlCartesianPlot(arg);
    }
    static setDefaultAxis(plot, options) {
        const axisComponents = core_1.CompositeGraphicsComponent
            .createOneLinked(new gl_cartesian_2d_trace_graphics_component_1.GlCartesian2dTraceGraphicsComponent(new gl_cartesian_2d_trace_binder_1.GlCartesian2dTraceBinder(), new gl_cartesian2d_camera_binder_1.GlCartesian2dCameraBinder()))
            .addComponent(new gl_cartesian_2d_axis_graphics_component_1.GlCartesian2dAxisGraphicsComponent(plot.attachPoint, new gl_cartesian_2d_trace_binder_1.GlCartesian2dTraceBinder(), new gl_cartesian2d_camera_binder_1.GlCartesian2dCameraBinder()))
            .build();
        plot.metaCategory.addEntity(new core_1.ChartDataEntity(new cartesian_2d_trace_entity_connector_1.Cartesian2dTraceEntityConnector(Float32Array, options.traceOptions.maxTraceCount, plot.changeIdFactory), {
            traceColor: options.traceOptions.traceColor,
            traceLinePixelSize: options.traceOptions.traceLinePixelSize,
            zIndexAbs: 0,
            zIndexRel: 0,
            axisOptions: options.axisConfig,
            traces: new Float32Array(2 * 4 * (options.traceOptions.maxTraceCount + 3)),
        }, plot.changeIdFactory, function onBeforeUpdate(arg) {
            this.changeId = this.data.update(arg.plotRange);
            (0, populate_cartesian_2d_trace_bindings_1.populateCartesian2dTraceBindings)(this);
        }), axisComponents);
    }
}
exports.GlCartesian2dPlotFactory = GlCartesian2dPlotFactory;
const GlCartesianPlot = (0, create_cartesian_plot_ctor_1.createCartesianPlotCtor)(GlCartesian2dPlotFactory, new gl_cartesian_update_hooks_1.GlCartesianUpdateHooks(arg => arg.plotDimensionsOBL.pixelArea.wholeRange), new gl_cartesian_update_hooks_1.GlCartesianUpdateHooks(arg => arg.plotDimensionsOBL.pixelArea.interactiveRange));
//# sourceMappingURL=gl-cartesian2d-plot-factory.js.map